import type { CartLine } from "@/types/order";
import type { CreateOrderDish, CreateOrderPayload } from "./OrdersAPI.model";

/**
 * The guest app has no seat identity, so everything is ordered for guest 1.
 * Multiple phones at one table therefore collapse onto a single guest, which
 * limits later "pay for your items" splitting — accepted for v1.
 */
export const DEFAULT_GUEST_NUMBER = 1;

/**
 * Expand cart lines into the server's per-unit shape: a line of quantity 3
 * becomes three identical dish entries, because CreateOrderDishDto has no
 * quantity field.
 */
export const buildCreateOrderPayload = (
  tableId: string,
  lines: CartLine[],
  guestNumber: number = DEFAULT_GUEST_NUMBER,
): CreateOrderPayload => {
  const dishes: CreateOrderDish[] = lines.flatMap((line) => {
    const unit: CreateOrderDish = {
      dishId: line.dishId,
      ...(line.size ? { sizeId: line.size.id } : {}),
      ...(line.extraNote ? { extraNote: line.extraNote } : {}),
      toppings: line.toppings.map((topping) => ({
        id: topping.id,
        quantity: topping.quantity,
      })),
    };
    return Array.from({ length: line.quantity }, () => ({ ...unit }));
  });

  return { tableId, guests: [{ guestNumber, dishes }] };
};
